import { render } from "./RolesList.vue?vue&type=template&id=3c557d92"
import script from "./RolesList.vue?vue&type=script&lang=js"
export * from "./RolesList.vue?vue&type=script&lang=js"

import exportComponent from "/Users/luke/Documents/contility/server/src/views/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__